// extracted by mini-css-extract-plugin
export default {"about__inner":"about_about__inner__2ylw4","about__title":"about_about__title__iucR0","about__dest":"about_about__dest__dSNtJ"};